import React, { useRef, useEffect } from 'react';
import useStore from '../../../../store';
import PuzzlePiece from './PuzzlePiece';
import './TrayPieces.css'; // Подключаем стили
import { IoIosArrowDown } from 'react-icons/io'; // Импортируем иконку

const TrayPieces = ({ puzzleRender }) => {

  useStore(state => state.puzzleRedraw);

  const { ref } = useStore.getState();
  const { puzzle, info } = ref;
  const { layout, state, config } = puzzle || {};
  const { pieces, imageScale, pieceBaseDimensions, draggingPiece, puzzleImageElement } = state || {};

  if (!pieces || !config || !imageScale || !pieceBaseDimensions || !layout?.trayPiecesLayout || !puzzleImageElement) {
    return null;
  }

  const { pieceLayoutData, sortedPieceIds, totalContentHeight } = layout.trayPiecesLayout;

  const now = Date.now();
  const debugMode = info.user.debugMode;

  const showScrollIndicator = totalContentHeight > layout.trayContainer.height + 50;

  const showShadowNow = puzzle.config.showTray && Date.now() > puzzle.config.showTray + 1000 ;

  const containerStyle = {
    width: `100%`,
    height: `${totalContentHeight || 0}px`,
    filter: showShadowNow ? `drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.377))` : `drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))`,
    transition: 'filter 0.4s cubic-bezier(0.4,0,0.2,1)',
  }

  return (
    <>
    {showScrollIndicator && (
      <IoIosArrowDown className="scroll-indicator" />
    )}
    <div className="tray-pieces-container" style={containerStyle}
    >
      {sortedPieceIds.slice(0).reverse().map(pieceId => {
        const piece = pieces[pieceId];
        const pieceLayout = pieceLayoutData[pieceId];

        if (!piece || !pieceLayout || !piece.baseDimensions) {
          return null;
        }

        const { scaledTabExtensions, scaledTotalDimensions } = puzzle.methods.calculateOnePiece(pieceId);

        const finalX = pieceLayout.x - scaledTabExtensions.width;
        const finalY = pieceLayout.y - scaledTabExtensions.height + config.compensation.trayYpx;

        const isDraggingThis = draggingPiece?.pieceId === pieceId;

        if (isDraggingThis) {
          if (draggingPiece.dragOrigin === 'tray') {
            return null; 
          }
        }

        
        const isReserved = piece.reservedUntil > now || piece.unreservedUntil > now - 1000;

        const isGhost = piece.visible && (isDraggingThis || piece.placed || piece.onBoard || isReserved);


        const style = {
          width: scaledTotalDimensions.width,
          height: scaledTotalDimensions.height,
          transform: `translate(${finalX}px, ${finalY}px) rotate(${piece.rotation}deg)`,
          transition: isGhost ? `transform 0.1s ease-in-out` : `transform 0.5s ease-in-out`,
        };


        const className = `tray-piece-item ${isGhost ? 'ghost' : ''} ${isReserved ? 'reserved' : ''} ${debugMode ? 'debug' : ''}`;

        return (
          <div
            key={pieceId}
            ref={el => {
              if (el) { 
                piece.pieceTrayElement = el;
                piece.pieceTrayRect = el.getBoundingClientRect();
              }
            }}
            className={className}
            style={style}
            onPointerDown={ isGhost ? null : (event) => {

              useStore.setState({ pointerPosition: { x: event.clientX, y: event.clientY } });

              const { trayPosition } = puzzle.methods.calculateOnePiece(pieceId);

              const offset = {
                x: event.clientX - trayPosition.x,
                y: event.clientY - trayPosition.y
              };

              puzzle.methods.startDragging(pieceId, event, offset, 'tray');

              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <PuzzlePiece
              pieceId={pieceId}
              overrideStyle={{ transform: `none` }}
              scaleFactor={imageScale}
            />
          </div>
        );
      })}
    </div>
    </>

  );
};

export default TrayPieces;
// export default React.memo(TrayPieces);
